import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" {...props}><path fill="#1e1e1e" fillRule="evenodd" d="M5.54 2.16l14 9a1 1 0 010 1.683l-14 9A1 1 0 014 21.002v-18a1 1 0 011.54-.842z" /></svg>);